import type { FicheComplete } from "@sfs/contracts";
import { api } from "@shared/lib/apiClient";

export const ficheApi = {
  complete: (id: string) => api.get<FicheComplete>(`/prospects/${id}/fiche`),
  verifierSignal: (signalId: string, statut: "confirme_client" | "infirme_client" | "non_verifie") =>
    api.patch(`/signaux/${signalId}/verification`, { statut }),
  genererArgumentaire: (prospectId: string) => api.post(`/argumentaire/${prospectId}/generer`),
  genererSequence: (prospectId: string) => api.post(`/actions/prospect/${prospectId}/sequence`),
  majAction: (id: string, statut: string) => api.patch(`/actions/${id}`, { statut })
};
